export default {
    api_server: (process.env.NODE_ENV !== "development" ? "/api/v1" : "http://sensor-api/v1"),
    app_id: "mdevelopment-vue",
    app_secret: "12345", // @TODO: Not to be defined here. Use proxy for login instead
    maps_key: process.env.MAPS_KEY,
    maps_id: process.env.MAPS_ID
}



// WEBPACK FOOTER //
// ./src/config.js